import { getPanoramaClient } from './panorama';

export type RequestOperation =
  | 'search-templates'
  | 'browse-templates'
  | 'fetch-templates'
  | 'fetch-search-suggestions'
  | 'send-template-email';
let nextRequestId = 0;

// Keep request timing separate from UI transactions. Each attempt gets its own ID
// so overlapping requests (such as autocomplete) cannot finish one another.
export async function monitorRequest<T>(operation: RequestOperation, request: () => Promise<T>): Promise<T> {
  const transaction = getPanoramaClient()?.transaction(operation, { id: `request-${++nextRequestId}` });
  transaction?.start();
  const result = await request();
  transaction?.finish();
  return result;
}
// Rejections propagate unchanged. The caller reports the error and retains its UI
// handling; unsuccessful requests intentionally have no successful finish event.
